module.exports = __webpack_public_path__ + "media/app/assets/races/worgen_male-4864be160b71df59b22172b5f3d8bdb6.png";